import { useState } from 'react';
import { localStorageKeys } from '@sketch/constants';
import { getParsedItem, setStringifiedItem } from '@sketch/utils';

const useHero = () => {
    var _a;
    const [dismissedHeroes, setDismissedHeroes] = useState((_a = getParsedItem(localStorageKeys.discoverDismissedHeros)) !== null && _a !== void 0 ? _a : []);
    const dismissHero = id => {
        const newDismissedHeroes = [id, ...dismissedHeroes];
        setStringifiedItem(localStorageKeys.discoverDismissedHeros, newDismissedHeroes);
        setDismissedHeroes(newDismissedHeroes);
    };
    return { dismissedHeroes, dismissHero };
};

export { useHero };
